<template>
  <div class="slb-cert-container init">
    <div class="cps-page-top">
      <!--头部-->
      <div class="jc-page-header">
		<el-page-header show-back-icon :title="$t('slb.text.cert')" @back="goBack" class="relative">
			<template slot="content">
				<span class="long-name" :title="detail.name">
					{{detail.name}}
				</span>						
				<div class="jc-list__header--right jc-box-action">
					<!--帮助文档-->
					<a v-bind:href="Config.SLB_HELP_URL" target="_blank">
						{{$t('slb.text.slbHelpDoc')}}
					</a>
					<!--操作-->
					<drop-down-operation :buttonTitle="$t('privateNetInstance.operate')"
						:operations='operations'
						@clickSelectItem="clickOperate">
					</drop-down-operation>        
				</div>
			</template>
		</el-page-header>       
      </div>
      <div class="jc-page-content">
        <el-tabs type="border-card">
          <!-- 资源信息 -->
          <el-tab-pane :label="$t('detail.text.sourceInfo')">
            <!-- 基本信息 -->
            <div class="jc-section">
                <div class="jc-section-header">
                  <h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
                </div>
                <div class="jc-section-content">
                  <el-form class="base-info-list">
                    <el-row :gutter="20">
                      <!-- 名称 -->
                      <el-col :span="8">
                        <el-form-item :label="$t('slb.text.name') | withColon">
                          <span :title="detail.name" class="instance-name">{{ detail.name }}</span>
                            <el-popover ref="editValue"
                              class="h30"
                              trigger="click"
                              :visible-arrow="false"
                              :offset="0"
                              placement="left-start"
                              :width="300"
                              v-if="showEditName"
                              :value="showEditName">
                              <edit-value
                                :inputVal="detail.name"
                                v-if="showEditName"
                                @sureEdit="editName"
                                :inputValRule="rules.name"
                                :showEditDes.sync="showEditName"
                                :popTitle="$t('privateNetwork.editName')">
                              </edit-value>
                            </el-popover>
                            <el-button type="text" icon="jc-icon-edit"
                              @click="showEditName = true"
                              v-popover:editValue>
                            </el-button>
                            <div class="jc-colude-mask" v-if="showEditName"></div>
                        </el-form-item>
                      </el-col>
                      <!-- 证书内容 -->
                      <el-col :span="8">
                        <el-form-item :label="$t('slb.text.certContent') | withColon">
							<div class="stringOmit" :title="detail.certificate">
							<span>{{detail.certificate}}</span>
							</div>
						</el-form-item>
                      </el-col>
                      <!-- 地域 -->
                      <el-col :span="8">
                        <el-form-item :label="$t('create.text.region') | withColon">
                          <p>{{transformRegion(region)}}</p>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
            </div>
            <!-- 关联监听 -->
            <div class="jc-section">
              <div class="jc-section-header">
                  <h3 class="jc-section-title">{{ $t('slb.text.associatedMonitor') }}</h3>
                </div>
                <div class="jc-section-content">
                  <el-table border
				  	:data="listenerListData" 
					v-loading="listenerListLoading"
					style="width: 100%"
                    ref="listTable">
                    <el-table-column prop="name" :label="$t('slb.text.name')">
                    	<template scope="scope">
							<a href="javascript:void(0)"
							@click="jumpToListenerDetail(scope.row.listenerId)">
							{{ scope.row.name }}
							</a>
						</template>
                    </el-table-column>
					<el-table-column prop="protocol" :label="$t('slb.text.monitorProtocol')">
						<template slot-scope="scope">
                            	<span>{{scope.row.protocol + ': ' + scope.row.port}}</span>
                        </template>
					</el-table-column>
                  </el-table>
                </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <delete-cert 
          :visible.sync="deleteCertVisible"
          @refresh="goBack"
          :rowInfo="detail"
          :pageSource="'list'">
        </delete-cert>
      </div>
    </div>
  </div>
</template>

<script>
import editValue from '@/components/privateNetwork/EditValue';
import deleteCert from '@/components/slb/deleteCert';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
export default {
  components:{
    editValue,
    deleteCert,
    dropDownOperation,
  },
  data(){
	const valName = (rule, value, callback) => {
      const nameRule = /^[-0-9a-zA-Z_\u4e00-\u9fa5]{1,32}$/;
      if (!value) {
        callback(new Error(this.$t('privateNetwork.nameNotNull')));
      } else if (!nameRule.test(value)) {
        callback(new Error(this.$t('privateNetwork.nameHelp')));
      } else {
        callback();
      }
    };
    return {
      	rules: {
				name: [
				  {
					validator: valName,
				  },
				],
			},
		operations: [],
		detail: {},
		slbRegions: {},
		certId: '',
		showEditName: false,
		// 监听器列表loading状态
		listenerListLoading: false,
		deleteCertVisible: false,
		// SLB证书对应的监听器列表
		listenerListData: [],
		listenerCount:0,
    }
  },
  async created() {
    this.region = this.$route.query.region;
	this.certId = this.$route.query.certId;
	await this.getRegions();
    this.getslbCertDetail();	
	this.getslbListenerDetail();
  },
  methods: {
    //返回详情页
    goBack() {
      	this.$router.push({
				path: `/lb/cert/list`,
			});
    },
    //编辑名称
    editName(value) {
			const params = {
				region: this.detail.region,
				certId: this.detail.certId,
				name: value,
				clientToken: Normal.getClientToken(),
			};
		  	Ajax.post('/api/cps/updateCertificate', params)
			.then((res) => {
				if (res.errno === 10000) {
					this.detail.name = value;
					this.$message.success(this.$t('subnet.text.operationSuccess'));
				}
			}).finally(() => {
				this.getslbCertDetail()
			});
		},
    clickOperate(item) {
			switch (item) {
				case 'delete':
					this.deleteCertVisible = true;
					break;
				default:
					break;
			}
		},
    initOperations() {
      	const operations = [];
		// 删除实例
		const deleteOperate = {
			operateName: this.$t('operations.delete.name'),
			disabled: this.listenerCount> 0,
			tip: this.$t('slb.sentence.cannotDelete'),
			value: 'delete'
		};
		operations.push(deleteOperate);
		return operations;
	},
    getslbCertDetail() {
	  	const param = {
			region: this.region,
			certId: this.certId,
		};
	  	Ajax.get('/api/cps/findCertificate', param)
		.then((res) => {
				const data = res.data;
				this.detail = data.certificate;
			}
		)
		.catch(async (err) => {
			const {response} = err.data;
			try {
				const json = await response.json();
				target.$message.error(json.errmsg);
			} catch (ex) {
				console.log(ex);
			}
		})
		.finally(() => {
		})

    },
	getslbListenerDetail() {
		this.listenerListLoading = true;
	  	const param = {
			region: this.region,
			pageNumber:1,
			certId:this.certId,
			pageSize:20,
		};
	  	Ajax.get('/api/cps/listListeners', param)
		.then((res) => {
				const data = res.data;
				this.listenerCount = data.totalCount;
				this.listenerListData = data.listeners;
				this.listenerListLoading = false;
		})
		.catch(async (err) => {
			const {response} = err.data;
			try {
				const json = await response.json();
				target.$message.error(json.errmsg);
			} catch (ex) {
				console.log(ex);
			}
		})
		.finally(() => {
			this.listenerListLoading = false;
			this.operations = this.initOperations();
		})

    },
	//跳转到监听器详情
	jumpToListenerDetail(id) {
		this.$router.push({
			path: '/lb/listener/detail',
			query: {
				id,
				region: this.region
			}
		});
	},
	transformRegion(region) {
      return this.slbRegions[region];
    },
	getRegions() {
		return Ajax.get('api/cps/cpslbRegions')
		.then((res) => {
			res.data.regions.forEach((region) => {
				this.slbRegions[region.region] = region.regionName;
			});
		});
    },
  }
}

</script>

<style lang="scss" scope>
	@import "style";
		.h30 {
				line-height: 30px;
			}

		a {
			font-size: 12px;
			margin-right: 5px;
			color: #2C68FF;
		}

		.stringOmit {
			table-layout:fixed;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.jc-select-form-item .el-dropdown-menu__item{
			width: 60px;
		}

		.jc-section-title{
			font-size: 14px;
			margin-bottom: 10px;
		}
</style>

<style lang="scss">
.slb-cert-container {
	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-disabled {
    color: #2C68FF;
    border-top: 1px solid #2C68FF;
  }

  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #2C68FF
  }
}
 
</style>


// WEBPACK FOOTER //
// src/views/slb/cert/detail/Detail.vue